import OfferMainContent from './OfferMainContent';

export default OfferMainContent;
